<template>
  <v-container>
    <v-layout
      row
      wrap
    >
      <v-flex
        xs-12
      >
        <v-card>
          <v-card-title
            dark
          >
            <h3>{{ video.title }}</h3>
          </v-card-title>
          <v-img
            :src="video.imageUrl"
            contain
            height="600px"
          />
          <v-card-text>
            <div class="info--text">
              Streamed {{ video.date | date }} | 55 mins
            </div>
            <div>
              A really fun ballet class! Give it a try.
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              class="primary"
            >
              Start Video
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    props: ['id'],
    computed: {
      video () {
        return this.$store.getters.loadedVideo(this.id)
      }
    }
  }
</script>
